import { handleActions } from 'redux-actions';
import { setLeftOcrCurrentViewPageNumber } from 'store/actions/ocr-current-view-page-number-actions';
import { clearStatementPageStoreAction } from 'store/actions/statement-content-actions';

export default handleActions(
  {
    [setLeftOcrCurrentViewPageNumber]: (store, { payload }) => {
      return payload;
    },
    [clearStatementPageStoreAction]: () => {
      return 1;
    },
  },
  1,
);
